import React from 'react';

const Footer = ({ activeNavItem, setActiveNavItem }) => {
  return (
    <footer className="app-footer">
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="copyright">
            © 2025 BroaderBusiness. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <button 
              className="footer-bottom-link" 
              onClick={() => setActiveNavItem('privacy')}
            >
              Privacy
            </button>
            <button 
              className="footer-bottom-link" 
              onClick={() => setActiveNavItem('terms')}
            >
              Terms
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;